import React, { FC, ReactElement } from 'react';
import { Field } from 'formik';
import Input from '../Input/Input/Input';
import FootNote from '../FootNote';
import Label from '../Label';

interface Props {
  name: string;
  label?: string | ReactElement;
  required?: boolean;
  type?: string;
  placeholder?: string;
}

const FormField: FC<Props> = ({ name, label, required, placeholder }) => {
  return (
    <Field name={name} required>
      {({ field, meta }) => {
        const isRegularFieldError = meta.touched && meta.error;
        return (
          <div className="flex flex-col">
            <Label message={label} required={required} />
            <Input
              {...field}
              inputClassName="text-mako"
              inputWrapperClassName="border-alto/50 h-10"
              isWrong={!!meta.error}
              placeholder={placeholder}
            />
            {isRegularFieldError && <FootNote isError message={meta.error} />}
          </div>
        );
      }}
    </Field>
  );
};

export default FormField;
